import { plainToClass } from "class-transformer";
import { CommunicationDropdown, ProjectFile, CommunicationAttachment, CommunicationsListingDto } from "../communications.objects";
import { AssignedSiteStudyDto, SaveActionItemDto } from "../../action-items/action-items.objects";
import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter } from "../../../../shared/scripts/filtering/filtering.entities";
import { InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";
import { getData } from "../../sites/scripts/site.utilities";

export class CommunicationDialog implements IFilter {
    communicationTypes: CommunicationDropdown[];
    communicationTopics: CommunicationDropdown[];
    communicationStatuses: CommunicationDropdown[];
    attachmentTypes: CommunicationDropdown[];
    actionItemTypes: CommunicationDropdown[];
    actionItemStatuses: CommunicationDropdown[];
    actionItemCriticalTypes: CommunicationDropdown[];
    allCommunications: any[];
    allSites: any[];
    allContacts: any[];
    allUsers: any[];
    sitesTable: any;
    contactsTable: any;
    usersTable: any;
    actionItemsTable: any;
    attachmentsTable: any;
    siteFilterDropdownIds: string[];
    contactFilterDropdownIds: string[];
    userFilterDropdownIds: string[];
    actionItemFilterDropdownIds: string[];
    attachmentFilterDropdownIds: string[];
    checkedSiteIds: Set<number> = new Set();
    checkedContactIds: Set<number> = new Set();
    checkedUserIds: Set<number> = new Set();
    checkedActionItemIds: Set<number> = new Set();
    uploadInput: JQuery<HTMLElement>;
    files: File[];
    uploadedFiles: ProjectFile[];
    attachments: CommunicationAttachment[] = [];
    excludedS3Ids: string[] = [];
    actionItems: any[] = [];
    changedActionItems: SaveActionItemDto[] = [];

    successCallback: (response: any) => void;

    constructor(allCommunicationsJson: any, allCommunicationTypesJson: any, allCommunicationTopicsJson: any, allCommunicationStatusesJson: any, allAttachmentTypesJson: any, allSitesJson: any, allContactsJson: any, allUsersJson: any) {
        $(() => {
            // Hide Add/Edit tab and tab link by default
            $('#tabactionItemLink2').hide();
            $('#commActionItemTab2Wrapper').hide();
            this.allCommunications = plainToClass(Object, <any[]>allCommunicationsJson);
            this.communicationTypes = plainToClass(CommunicationDropdown, <CommunicationDropdown[]>allCommunicationTypesJson);
            this.communicationTopics = plainToClass(CommunicationDropdown, <CommunicationDropdown[]>allCommunicationTopicsJson);
            this.communicationStatuses = plainToClass(CommunicationDropdown, <CommunicationDropdown[]>allCommunicationStatusesJson);
            this.attachmentTypes = plainToClass(CommunicationDropdown, <CommunicationDropdown[]>allAttachmentTypesJson);
            this.allSites = plainToClass(Object, <any[]>allSitesJson);
            this.allContacts = plainToClass(Object, <any[]>allContactsJson);
            this.allUsers = plainToClass(Object, <any[]>allUsersJson);
            this.siteFilterDropdownIds = [
                '#filter-site-study-dropdown'
            ];
            this.contactFilterDropdownIds = [
                '#filter-contact-study-dropdown', '#filter-contact-role-dropdown'
            ];
            this.userFilterDropdownIds = [
                '#filter-user-study-dropdown'
            ];
            this.actionItemFilterDropdownIds = [
                '#commActionItem-site-dropdown', '#commActionItem-status-dropdown', '#commActionItem-type-dropdown'
            ];
            this.attachmentFilterDropdownIds = [
                '#communicationEvent-attachmentType-dropdown'
            ];
            this.uploadInput = $("#communicationsFile").first();
            this.files = [];
            this.uploadedFiles = [];
            this.loadOptionData();
            this.chooseFileDrop();
            this.populateDialogDropdowns();
            this.initializeSitesTable();
            this.initializeContactsTable();
            this.initializeUsersTable();
            this.initializeActionItemsTable();
            this.initializeSitesFilters();
            this.initializeContactsFilters();
            this.initializeUsersFilters();
            this.initializeActionItemsFilters();
            this.initializeCriticalTypeToggle();
            this.initializeAttachmentsTable();
            $('#newCommunicationEventDialog').on('shown.bs.modal', () => {
                if (this.sitesTable) {
                    this.sitesTable.columns.adjust();
                }
                if (this.contactsTable) {
                    this.contactsTable.columns.adjust();
                }
                if (this.usersTable) {
                    this.usersTable.columns.adjust();
                }
                if (this.actionItemsTable) {
                    this.actionItemsTable.columns.adjust();
                }
                if (this.attachmentsTable) {
                    this.attachmentsTable.columns.adjust();
                    this.renderAttachmentsTable();
                }
            });
            $('#communicationDialogAttachmentSection').on('shown.bs.collapse', () => {
                if (this.attachmentsTable) {
                    this.attachmentsTable.columns.adjust();
                }
            });
            $('#communicationActionItemsSection').on('shown.bs.collapse', () => {
                if (this.actionItemsTable) {
                    this.actionItemsTable.columns.adjust();
                }
            });
            // Adjust columns when switching tabs in the dialog
            $('#newCommunicationEventDialog .ctms-st-menu a[data-toggle="tab"]').on('shown.bs.tab', () => {
                if ($('#tab1').hasClass('active') && this.sitesTable) {
                    this.sitesTable.columns.adjust();
                }
                if ($('#tab2').hasClass('active') && this.contactsTable) {
                    this.contactsTable.columns.adjust();
                }
                if ($('#tab3').hasClass('active') && this.usersTable) {
                    this.usersTable.columns.adjust();
                }
            });
            $('#communicationDialogTabSection').on('shown.bs.collapse', () => {
                if ($('#tab1').hasClass('active') && this.sitesTable) {
                    this.sitesTable.columns.adjust();
                }
                if ($('#tab2').hasClass('active') && this.contactsTable) {
                    this.contactsTable.columns.adjust();
                }
                if ($('#tab3').hasClass('active') && this.usersTable) {
                    this.usersTable.columns.adjust();
                }
            });
            $('#newCommunicationEventDialog').on('hidden.bs.modal', () => {
                this.checkedSiteIds.clear();
                this.checkedContactIds.clear();
                this.checkedUserIds.clear();
                this.checkedActionItemIds.clear();
                this.actionItems = [];
                this.clearDialogFields();
                this.resetSitesFilters();
                this.resetContactsFilters();
                this.resetUsersFilters();
                this.initializeActionItemsFilters();
                this.resetActionItemsFilters();
                this.resetAttachmentsFilters();
                this.clearAndCloseActionItemDialogFields();
                const validationError = document.getElementById('validation-error');
                validationError.classList.add('d-none');
                const validationErrorSite = document.getElementById('validation-error-site');
                validationErrorSite.classList.add('d-none');
                const validationErrorFile = document.getElementById('validation-error-file');
                validationErrorFile.classList.add('d-none');
            });
            $('#communications-file-clear').on('click', function () {
                $('#communicationsFile').val('');
            });
            // Add save button initialization
            this.initializeSaveButton();
            $('#communicationsFileAdd').on('click', () => {
                const fileInput = $('#communicationsFile')[0] as HTMLInputElement;
                const files = fileInput.files;
                const typeId = $('#communicationsAttachmentType').val() as string;
                const otherDescription = $('#communicationAttachmentTypeOther').val() as string;
                if (files && files.length > 0 && typeId) {
                    const file = files[0];
                    this.attachments.push({ id: 0, file, typeId, fileName: file.name, s3Id: '', otherDescription: otherDescription });
                    this.renderAttachmentPills();
                    // Clear controls
                    $('#communicationsFile').val('');
                    $('#communicationsAttachmentType').val('').trigger('change');
                }
            });
            $('#newCommActionItemBtn').on('click', () => {
                this.clearActionItemDialogFields();
                // Show Add/Edit tab and tab link, switch to it
                $('#tabactionItemLink2').show();
                $('#commActionItemTab2Wrapper').show();
                $('#tabactionItemLink2').text('New Action Item');
                $('#tabactionItemLink2').tab('show');
                $('#commActionItemId').val(0);
                $('#addActionItemFieldsSection').show();
                // Disable save button and add tooltip
                $('#saveCommunicationEventDialogBtn').prop('disabled', true).attr('title', "Disabled while adding or editing an action item");
            });
            $('#cancelActionItemBtn').on('click', () => {
                this.clearAndCloseActionItemDialogFields();
            });
            $('#saveActionItemBtn').on('click', () => {
                // Gather field values
                const actionItem = new SaveActionItemDto();
                actionItem.Id = Number($('#commActionItemId').val());
                actionItem.TypeId = Number($('#commActionItemType').val());
                actionItem.TypeName = $('#commActionItemType option:selected').text();
                actionItem.Source = String($('#commActionItemSource').val());
                actionItem.StatusId = Number($('#commActionItemStatus').val());
                actionItem.DateIdentified = String($('#commActionItemDate').val());
                actionItem.DateDue = String($('#commActionItemDueDate').val());
                actionItem.IsUrgent = Boolean($('#commActionItemUrgent').prop('checked'));
                actionItem.IsCritical = Boolean($('#commActionItemCritical').prop('checked'));
                const criticalTypeVal = $('#commActionItemCriticalType').val();
                actionItem.CriticalTypeId = criticalTypeVal === '' ? null : Number(criticalTypeVal);
                actionItem.Notes = String($('#commActionItemNotes').val());
                // Add to array
                this.changedActionItems.push(actionItem);
                // Render pills
                this.renderActionItemPills();
                // Hide and clear fields
                $('#addActionItemFieldsSection').hide();
                this.clearAndCloseActionItemDialogFields();
            });
            // Ensure communication dialog modal cannot be closed by clicking outside
            $('#newCommunicationEventDialog').modal({
                backdrop: 'static',
                show: false
            });
        });
    }

    async loadOptionData() {
        var refData = await getData('/secure/ctms/action-items/action-items?handler=DialogReferenceOptionData');
        this.actionItemTypes = plainToClass(CommunicationDropdown, <CommunicationDropdown[]>refData.allActionItemTypesJson);
        this.actionItemStatuses = plainToClass(CommunicationDropdown, <CommunicationDropdown[]>refData.allActionItemStatusesJson);
        this.actionItemCriticalTypes = plainToClass(CommunicationDropdown, <CommunicationDropdown[]>refData.allActionItemCriticalTypesJson);

        const $actionTypeDropdown = $('#commActionItemType');
        $actionTypeDropdown.empty();
        this.actionItemTypes.forEach(type => {
            $actionTypeDropdown.append(`<option value="${type.Id}">${type.Name}</option>`);
        });

        const $actionStatusDropdown = $('#commActionItemStatus');
        $actionStatusDropdown.empty();
        this.actionItemStatuses.forEach(status => {
            $actionStatusDropdown.append(`<option value="${status.Id}">${status.Name}</option>`);
        });

        const $actionCriticalTypeDropdown = $('#commActionItemCriticalType');
        $actionCriticalTypeDropdown.empty();
        this.actionItemCriticalTypes.forEach(critical => {
            $actionCriticalTypeDropdown.append(`<option value="${critical.Id}">${critical.Name}</option>`);
        });
    }

    initializeCriticalTypeToggle(): void {
        const $criticalCheckbox = $('#commActionItemCritical');
        const $criticalTypeWrapper = $('#commActionItemCriticalTypeWrapper');
        $criticalCheckbox.on('change', function () {
            if ($(this).prop('checked')) {
                $criticalTypeWrapper.show();
            } else {
                $criticalTypeWrapper.hide();
                $('#commActionItemCriticalType').val('');
            }
        });
        // On page load, ensure correct visibility
        if (!$criticalCheckbox.is(':checked')) {
            $criticalTypeWrapper.hide();
            $('#commActionItemCriticalType').val('');
        }
    }

    private chooseFileDrop() {

        this.uploadInput.on("change", (e) => {
            let uploadedFiles: File[] = this.uploadInput.prop("files");

            if (uploadedFiles.length <= 0) {
                return;
            }

            for (let i = 0; i < uploadedFiles.length; i++) {
                this.files = [uploadedFiles[i]];

            }
        })
    }

    populateDialogDropdowns(): void {
        const $typeDropdown = $('#communicationType');
        $typeDropdown.empty();
        this.communicationTypes.forEach(type => {
            $typeDropdown.append(`<option value="${type.Id}">${type.Name}</option>`);
        });

        const $topicDropdown = $('#communicationTopic');
        $topicDropdown.empty();
        this.communicationTopics.forEach(topic => {
            $topicDropdown.append(`<option value="${topic.Id}">${topic.Name}</option>`);
        });

        const $statusDropdown = $('#communicationStatus');
        $statusDropdown.empty();
        this.communicationStatuses.forEach(status => {
            $statusDropdown.append(`<option value="${status.Id}">${status.Name}</option>`);
        });

        const $attachmentTypeDropdown = $('#communicationsAttachmentType');
        $attachmentTypeDropdown.empty();
        this.attachmentTypes.forEach(attachType => {
            $attachmentTypeDropdown.append(`<option value="${attachType.Id}">${attachType.Name}</option>`);
        });

        // Show/hide 'Other' field based on selection
        $attachmentTypeDropdown.on('change', function () {
            const selectedText = $(this).find('option:selected').text();
            if (selectedText.trim().toLowerCase() === 'other') {
                $('#communicationAttachmentTypeWrapper').show();
            } else {
                $('#communicationAttachmentTypeWrapper').hide();
                $('#communicationAttachmentTypeOther').val('');
            }
        });
        // Initial state
        $('#communicationAttachmentTypeWrapper').hide();
    }

    initializeSitesTable(): void {
        const self = this;
        this.sitesTable = $('#communications-sites-assign-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '30vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[2, 'asc']],
            columns: [
                {
                    data: null,
                    title: '<input type="checkbox" />',
                    className: "ctms-table-col-check",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<input type="checkbox" class="assign-checkbox" data-id="${row.Id}" />`;
                    }
                },
                { data: "SiteName", title: "Site Name" },
                { data: "SiteNumber", title: "Site Number" },
                { data: "StudyName", title: "Study" }
            ],
            data: this.allSites
        });

        // Listen for checkbox changes
        $('#communications-sites-assign-table tbody').on('change', '.assign-checkbox', function () {
            const id = Number($(this).attr('data-id'));
            if ($(this).prop('checked')) {
                self.checkedSiteIds.add(id);
            } else {
                self.checkedSiteIds.delete(id);
            }
            self.updateCheckedCounts();
        });

        // On table draw, restore checked state
        this.sitesTable.on('draw', function () {
            self.sitesTable.rows().every(function () {
                const $row = $(this.node());
                const rowData = this.data();
                const $checkbox = $row.find('.assign-checkbox');
                if ($checkbox.length && (self.checkedSiteIds.has(rowData.Id))) {
                    $checkbox.prop('checked', true);
                } else {
                    $checkbox.prop('checked', false);
                }
            });
            self.updateCheckedCounts();
        });
    }

    initializeContactsTable(): void {
        const self = this;
        this.contactsTable = $('#communications-contacts-assign-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '30vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[1, 'asc']],
            columns: [
                {
                    data: null,
                    title: '<input type="checkbox" />',
                    className: "ctms-table-col-check",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<input type="checkbox" class="assign-checkbox" data-id="${row.Id}" />`;
                    }
                },
                { data: "ContactName", title: "Name" },
                { data: "SiteNames", title: "Site(s)", render: (data) => Array.isArray(data) ? data.join(", ") : data },
                { data: "StudyNameAndRole", title: "Study", render: (data) => Array.isArray(data) ? data.slice().sort().join(", ") : data },
                //    { data: "StudyNames", title: "Study", render: (data) => Array.isArray(data) ? data.slice().sort().join(", ") : data },
                //    { data: "Role", title: "Role" }
            ],
            data: this.allContacts
        });

        $('#communications-contacts-assign-table tbody').on('change', '.assign-checkbox', function () {
            const id = Number($(this).attr('data-id'));
            if ($(this).prop('checked')) {
                self.checkedContactIds.add(id);
            } else {
                self.checkedContactIds.delete(id);
            }
            self.updateCheckedCounts();
        });

        this.contactsTable.on('draw', function () {
            self.contactsTable.rows().every(function () {
                const $row = $(this.node());
                const rowData = this.data();
                const $checkbox = $row.find('.assign-checkbox');
                if ($checkbox.length && (self.checkedContactIds.has(rowData.Id))) {
                    $checkbox.prop('checked', true);
                } else {
                    $checkbox.prop('checked', false);
                }
            });
            self.updateCheckedCounts();
        });

    }

    initializeUsersTable(): void {
        const self = this;
        this.usersTable = $('#communications-users-assign-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '30vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[1, 'asc']],
            columns: [
                {
                    data: null,
                    title: '<input type="checkbox" />',
                    className: "ctms-table-col-check",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<input type="checkbox" class="assign-checkbox" data-id="${row.Id}" />`;
                    }
                },
                { data: "Name", title: "Name" },
                { data: "Sites", title: "Site(s)", render: (data) => Array.isArray(data) ? data.join(", ") : data },
                { data: "Studies", title: "Study", render: (data) => Array.isArray(data) ? data.slice().sort().join(", ") : data }
            ],
            data: this.allUsers
        });

        $('#communications-users-assign-table tbody').on('change', '.assign-checkbox', function () {
            const id = Number($(this).attr('data-id'));
            if ($(this).prop('checked')) {
                self.checkedUserIds.add(id);
            } else {
                self.checkedUserIds.delete(id);
            }
            self.updateCheckedCounts();
        });

        this.usersTable.on('draw', function () {
            self.usersTable.rows().every(function () {
                const $row = $(this.node());
                const rowData = this.data();
                const $checkbox = $row.find('.assign-checkbox');
                if ($checkbox.length && (self.checkedUserIds.has(rowData.Id))) {
                    $checkbox.prop('checked', true);
                } else {
                    $checkbox.prop('checked', false);
                }
            });
            self.updateCheckedCounts();
        });
    }

    initializeActionItemsTable(): void {
        const self = this;
        this.actionItemsTable = $('#action-items-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '30vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[3, 'asc']], // Order by Due Date (column index changed)
            columns: [
                { data: "Type", title: "Type", render: (data, type, row) => row.isRemoved ? `<s>${data}</s>` : data },
                { data: "Status", title: "Status", render: (data, type, row) => row.isRemoved ? `<s>${data}</s>` : data },
                { data: "SiteName", title: "Site", render: (data, type, row) => row.isRemoved ? `<s>${data}</s>` : data },
                { data: "DateDue", title: "Due Date", render: (data, type, row) => row.isRemoved ? `<s>${data}</s>` : data },
                {
                    data: null,
                    title: "",
                    className: "ctms-table-col-actions",
                    orderable: false,
                    render: function (data, type, row) {
                        if (row.isRemoved) return "";
                        return '<button class="ctms-action-edit" title="Edit"><i class="ctms-icon-pencil"></i></button>' +
                               '<button class="ctms-action-delete ml-2" title="Remove"><i class="ctms-icon-close"></i></button>';
                    }
                }
            ],
            data: []
        });

        // Search field for action items
        $('#filter-actionItem-search-input').on('input', () => {
            this.actionItemsTable.search(String($('#filter-actionItem-search-input').val() ?? '')).draw();
        });
        $('#filter-actionItem-search-clear').on('click', () => {
            $('#filter-actionItem-search-input').val('');
            this.actionItemsTable.search('').draw();
        });

        // Pencil icon handler (edit)
        $('#action-items-table tbody').on('click', '.ctms-icon-pencil', (evt) => {
            this.clearActionItemDialogFields();
            // Show Add/Edit tab and tab link, switch to it
            $('#tabactionItemLink2').show();
            $('#commActionItemTab2Wrapper').show();
            $('#tabactionItemLink2').text('Edit Action Item');
            $('#tabactionItemLink2').tab('show');
            $('#commActionItemSectionSpinner').show();
            const row = $(evt.target).closest('tr');
            const data = this.actionItemsTable.row(row).data();
            if (!data || !data.Id) return;
            // Disable save button and add tooltip
            $('#saveCommunicationEventDialogBtn').prop('disabled', true).attr('title', "Disabled while adding or editing an action item");
            $.get('/secure/ctms/action-items/action-items?handler=ActionItemDto&id=' + data.Id, (response) => {
                if (response && response.success && response.actionItem) {
                    this.populateActionItemFieldsFromDto(response.actionItem);
                    $('#commActionItemSectionSpinner').hide();
                    $('#addActionItemFieldsSection').show();
                } else {
                    this.clearAndCloseActionItemDialogFields();
                    alert('Could not load action item for editing.');
                }
            });
        });

        // X button handler (delete)
        $('#action-items-table tbody').on('click', '.ctms-action-delete', function (evt) {
            const row = $(evt.target).closest('tr');
            const data = self.actionItemsTable.row(row).data();
            if (!data || !data.Id) return;
            if (confirm('Are you sure you want to remove this action item?')) {
                self.checkedActionItemIds.delete(data.Id);
                // Mark as removed
                const item = self.actionItems.find(item => item.Id === data.Id);
                if (item) item.isRemoved = true;
                // Update DataTable row
                self.actionItemsTable.row(row).data(item).draw();
            }
        });
    }

    initializeAttachmentsTable(): void {
        const self = this;
        this.attachmentsTable = $('#attachments-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '20vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[1, 'asc']],
            columns: [
                {
                    data: 'typeId',
                    title: 'Attachment Type',
                    width: '150px',
                    render: function (data, type, row) {
                        const typeObj = self.attachmentTypes.find(t => t.Id == data);
                        return typeObj ? typeObj.Name : data;
                    }
                },
                //{ data: 'fileName', title: 'File Name' }
                {
                    data: 'fileName',
                    title: 'File Name',
                    render: function (data, type, row) {
                        if (!row.s3Id) return data;
                        const s3Id = encodeURIComponent(row.s3Id);
                        const fileName = encodeURIComponent(row.fileName);
                        return `<a href="/secure/ctms/communications/communications?handler=DownloadAttachment&s3Id=${s3Id}&fileName=${fileName}" target="_blank">${data}</a>`;
                    }
                }
                , {
                    data: null,
                    orderable: false,
                    title: '',
                    width: '30px',
                    render: function (data, type, row, meta) {
                        return `<button class="ctms-attachment-remove ctms-button" data-id="${row.id}" title="Remove">Remove</button>`;
                    }
                }
            ],
            data: []
        });
        // Search field for contacts
        $('#custom-attachments-dt-search').on('input', () => {
            this.attachmentsTable.search(String($('#custom-attachments-dt-search').val() ?? '')).draw();
        });
        $('#clear-attachments-dt-search').on('click', () => {
            $('#custom-attachments-dt-search').val('');
            this.attachmentsTable.search('').draw();
        });
        this.attachmentsTable.on('draw', function () {
            $('.ctms-attachment-remove').off('click').on('click', function (e) {
                e.preventDefault();
                const id = $(this).data('id');
                const idx = self.attachments.findIndex(att => att.id === id);
                if (idx !== -1) {
                    const att = self.attachments[idx];
                    if (att.s3Id) {
                        self.excludedS3Ids = self.excludedS3Ids.filter(s3Id => s3Id !== att.s3Id);
                    }
                    self.attachments.splice(idx, 1);
                    self.renderAttachmentsTable();
                }
            });
        });
    }

    renderAttachmentsTable(): void {
        if (this.attachmentsTable) {
            this.attachmentsTable.clear();
            this.attachmentsTable.rows.add(this.attachments.filter(att => att.id != 0));
            this.attachmentsTable.draw();
        }
    }

    initializeSitesFilters(): void {
        // Study dropdown for sites
        let studyValues: string[] = Unique(this.allSites.map(site => site.StudyName), true, ["None Selected"]);
        InitializeFilterDropdown('#filter-site-study-dropdown', studyValues, this);
        $('#filter-site-study-dropdown').on('change', () => this.triggerSitesTableFilter());
        // Search field for sites
        $('#filter-sites-search-input').on('input', () => {
            this.sitesTable.search(String($('#filter-sites-search-input').val() ?? '')).draw();
        });
        $('#filter-sites-search-clear').on('click', () => {
            $('#filter-sites-search-input').val('');
            this.sitesTable.search('').draw();
        });
    }

    initializeContactsFilters(): void {
        // Study dropdown for contacts
        let studyValues: string[] = Unique([].concat(...this.allContacts.map(contact => contact.StudyNames)), true, ["None Selected"]);
        InitializeFilterDropdown('#filter-contact-study-dropdown', studyValues, this);
        // Role dropdown for contacts
        //let roleValues: string[] = Unique(this.allContacts.map(contact => contact.Role).filter(r => r), true, ["None Selected"]);
        let roleValues: string[] = Unique([].concat(...this.allContacts.map(contact => contact.Role)), true, ["None Selected"]);
        InitializeFilterDropdown('#filter-contact-role-dropdown', roleValues, this);
        $('#filter-contact-study-dropdown, #filter-contact-role-dropdown').on('change', () => this.triggerContactsTableFilter());
        // Search field for contacts
        $('#filter-contacts-search-input').on('input', () => {
            this.contactsTable.search(String($('#filter-contacts-search-input').val() ?? '')).draw();
        });
        $('#filter-contacts-search-clear').on('click', () => {
            $('#filter-contacts-search-input').val('');
            this.contactsTable.search('').draw();
        });
    }

    initializeUsersFilters(): void {
        // Study dropdown for users
        let studyValues: string[] = Unique([].concat(...this.allUsers.map(user => user.Studies)), true, ["None Selected"]);
        InitializeFilterDropdown('#filter-user-study-dropdown', studyValues, this);
        $('#filter-user-study-dropdown').on('change', () => this.triggerUsersTableFilter());
        // Search field for users
        $('#filter-users-search-input').on('input', () => {
            this.usersTable.search(String($('#filter-users-search-input').val() ?? '')).draw();
        });
        $('#filter-users-search-clear').on('click', () => {
            $('#filter-users-search-input').val('');
            this.usersTable.search('').draw();
        });
    }

    initializeActionItemsFilters(): void {
        $('#commActionItem-type-dropdown').empty();
        $('#commActionItem-site-dropdown').empty();
        $('#commActionItem-status-dropdown').empty();
        // Type filter
        let typeValues: string[] = this.actionItems.map(ai => ai.Type);
        InitializeFilterDropdown('#commActionItem-type-dropdown', Unique(typeValues, true, ["None Selected"]), this);
        // Site filter
        let siteValues: string[] = this.actionItems.map(ai => ai.SiteName);
        InitializeFilterDropdown('#commActionItem-site-dropdown', Unique(siteValues, true, ["None Selected"]), this);
        // Status filter
        let statusValues: string[] = this.actionItems.map(ai => ai.Status);
        InitializeFilterDropdown('#commActionItem-status-dropdown', Unique(statusValues, true, ["None Selected"]), this);
        // Filter triggers
        $('#commActionItem-type-dropdown, #commActionItem-site-dropdown, #commActionItem-status-dropdown').on('change', () => this.triggerActionItemsTableFilter());
    }

    initializeAttachmentsFilters(): void {
        $('#communicationEvent-attachmentType-dropdown').empty();
        // Type filter
        let typeIdValues: string[] = this.attachments.map(ai => ai.typeId);
        let typeValues: string[] = typeIdValues.map(tid => {
            const typeObj = this.attachmentTypes.find(t => String(t.Id) === tid);
            return typeObj ? typeObj.Name : tid;
        });
        InitializeFilterDropdown('#communicationEvent-attachmentType-dropdown', Unique(typeValues, true, ["None Selected"]), this);
        // Filter triggers
        $('#communicationEvent-attachmentType-dropdown').on('change', () => this.triggerAttachmentsTableFilter());
    }

    triggerAttachmentsTableFilter(): void {
        const selectedType = this.getSelectedDropdownValues('#communicationEvent-attachmentType-dropdown');
        const selectedTypeIds = this.attachmentTypes
            .filter(t => selectedType.includes(t.Name))
            .map(t => String(t.Id));
        let matchingAttachments = this.attachments.filter(attachment => {
            if (attachment.id != 0 && (!selectedType || selectedType.length === 0 || selectedType.includes("None Selected"))) return true;
            return selectedTypeIds.includes(attachment.typeId);
        });
        this.attachmentsTable.clear();
        this.attachmentsTable.rows.add(matchingAttachments).draw();
    }

    triggerSitesTableFilter(): void {
        const selectedStudy = this.getSelectedDropdownValues('#filter-site-study-dropdown');
        let matchingSites = this.allSites.filter(site => {
            if (!selectedStudy || selectedStudy.length === 0 || selectedStudy.includes("None Selected")) return true;
            return selectedStudy.includes(site.StudyName);
        });
        this.sitesTable.clear();
        this.sitesTable.rows.add(matchingSites).draw();
    }

    triggerContactsTableFilter(): void {
        const selectedStudy = this.getSelectedDropdownValues('#filter-contact-study-dropdown');
        const selectedRole = this.getSelectedDropdownValues('#filter-contact-role-dropdown');
        let matchingContacts = this.allContacts.filter(contact => {
            let studyMatch = (!selectedStudy || selectedStudy.length === 0 || selectedStudy.includes("None Selected")) || contact.StudyNames.some((sn: string) => selectedStudy.includes(sn));
            let roleMatch = (!selectedRole || selectedRole.length === 0 || selectedRole.includes("None Selected")) || contact.Role.some((rn: string) => selectedRole.includes(rn));
            //let roleMatch = (!selectedRole || selectedRole.length === 0 || selectedRole.includes("None Selected")) || selectedRole.includes(contact.Role);
            return studyMatch && roleMatch;
        });
        this.contactsTable.clear();
        this.contactsTable.rows.add(matchingContacts).draw();
    }

    triggerUsersTableFilter(): void {
        const selectedStudy = this.getSelectedDropdownValues('#filter-user-study-dropdown');
        let matchingUsers = this.allUsers.filter(user => {
            if (!selectedStudy || selectedStudy.length === 0 || selectedStudy.includes("None Selected")) return true;
            return user.Studies && user.Studies.some((study: string) => selectedStudy.includes(study));
        });
        this.usersTable.clear();
        this.usersTable.rows.add(matchingUsers).draw();
    }

    triggerActionItemsTableFilter(): void {
        const selectedType = this.getSelectedDropdownValues('#commActionItem-type-dropdown');
        const selectedSite = this.getSelectedDropdownValues('#commActionItem-site-dropdown');
        const selectedStatus = this.getSelectedDropdownValues('#commActionItem-status-dropdown');
        let matchingItems: any[] = [];
        this.actionItems.forEach(item => {
            let typeMatch = (!selectedType || selectedType.length === 0 || selectedType.includes("None Selected")) || selectedType.includes(item.Type);
            let siteMatch = (!selectedSite || selectedSite.length === 0 || selectedSite.includes("None Selected")) || selectedSite.includes(item.SiteName);
            let statusMatch = (!selectedStatus || selectedStatus.length === 0 || selectedStatus.includes("None Selected")) || selectedStatus.includes(item.Status);
            if (typeMatch && siteMatch && statusMatch) {
                matchingItems.push(item);
            }
        });
        this.actionItemsTable.clear();
        this.actionItemsTable.rows.add(matchingItems).draw();
    }

    getSelectedDropdownValues(selectId: string): any {
        return $(selectId).val();
    }

    triggerFilter(): void {
        // Implement filter logic if needed
    }

    resetSitesFilters(): void {
        this.siteFilterDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('refresh');
        });
        $('#filter-sites-search-input').val('');
        if (this.sitesTable) {
            this.sitesTable.search('').draw();
            this.sitesTable.clear();
            this.sitesTable.rows.add(this.allSites).draw();
        }
    }

    resetContactsFilters(): void {
        this.contactFilterDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('refresh');
        });
        $('#filter-contacts-search-input').val('');
        if (this.contactsTable) {
            this.contactsTable.search('').draw();
            this.contactsTable.clear();
            this.contactsTable.rows.add(this.allContacts).draw();
        }
    }

    resetUsersFilters(): void {
        $('#filter-users-search-input').val('');
        if (this.usersTable) {
            this.usersTable.search('').draw();
            this.usersTable.clear();
            this.usersTable.rows.add(this.allUsers).draw();
        }
    }

    resetActionItemsFilters(): void {
        this.actionItemFilterDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('refresh');
        });
        $('#filter-actionItem-search-input').val('');
        if (this.actionItemsTable) {
            this.actionItemsTable.search('').draw();
            this.actionItemsTable.clear();
            this.actionItemsTable.rows.add(this.actionItems).draw();
        }
    }

    resetAttachmentsFilters(): void {
        this.attachmentFilterDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('refresh');
        });
        $('#custom-attachments-dt-search').val('');
        if (this.attachmentsTable) {
            this.attachmentsTable.search('').draw();
            this.renderAttachmentsTable();
        }
    }

    updateCheckedCounts(): void {
        // Sites
        $("#tabLink1 .ctms-count").text(this.checkedSiteIds.size);
        // Contacts
        $("#tabLink2 .ctms-count").text(this.checkedContactIds.size);
        // Users
        $("#tabLink3 .ctms-count").text(this.checkedUserIds.size);
    }

    clearDialogFields(): void {
        $('#communicationType').val($('#communicationType option:first').val()).trigger('change');
        $('#communicationTopic').val($('#communicationTopic option:first').val()).trigger('change');
        $('#communicationStatus').val($('#communicationStatus option:first').val()).trigger('change');
        $('#communicationsAttachmentType').val($('#communicationsAttachmentType option:first').val()).trigger('change');
        $('#communicationDate').val('');
        $('#communicationNotes').val('');
        $('#communicationId').val('');
        $('#communicationsFile').val('');
        $('#communicationEventSignificant').prop('checked', false);
        this.updateCheckedCounts();
        this.attachments = [];
        this.excludedS3Ids = [];
        this.checkedActionItemIds.clear();
        this.renderAttachmentPills();
        this.renderAttachmentsTable();
        this.changedActionItems = [];
        this.renderActionItemPills();
    }

    clearActionItemDialogFields(): void {
        $('#commActionItemId').val(0);
        $('#commActionItemType').val($('#commActionItemType option:first').val());
        $('#commActionItemSource').val('');
        $('#commActionItemStatus').val($('#commActionItemStatus option:first').val());
        $('#commActionItemDate').val('');
        $('#commActionItemDueDate').val('');
        $('#commActionItemUrgent').prop('checked', false);
        $('#commActionItemCritical').prop('checked', false).trigger('change');
        $('#commActionItemCriticalType').val('');
        $('#commActionItemNotes').val('');
    }

    clearAndCloseActionItemDialogFields(): void {
        this.clearActionItemDialogFields();
        // Hide Add/Edit tab and tab link, switch back to View tab
        $('#tabactionItemLink2').hide();
        $('#commActionItemTab2Wrapper').hide();
        $('#tabactionItemLink1').tab('show');
        $('#addActionItemFieldsSection').hide();
        $('#commActionItemSectionSpinner').hide();
        // Enable save button and remove tooltip
        $('#saveCommunicationEventDialogBtn').prop('disabled', false).removeAttr('title');
    }

    initializeSaveButton(): void {
        const self = this;
        $('#saveCommunicationEventDialogBtn').on('click', () => {
            if (this.validateForm()) {
                $('#saveCommunicationEventDialogBtn').prop('disabled', true);
                $('#communicationEventSaveSpinner').show();
                const formData = new FormData();
                formData.append('Id', $('#communicationId').val() as string);
                formData.append('TypeId', $('#communicationType').val() as string);
                formData.append('TopicId', $('#communicationTopic').val() as string);
                formData.append('StatusId', $('#communicationStatus').val() as string);
                formData.append('Date', $('#communicationDate').val() as string);
                formData.append('Notes', $('#communicationNotes').val() as string);
                formData.append('IsSignificant', $('#communicationEventSignificant').prop('checked') ? 'true' : 'false');
                formData.append('AssignedSites', JSON.stringify(self.getSelectedAssignedSitesDetailed()));
                formData.append('AssignedContacts', JSON.stringify(self.getSelectedAssignedContacts()));
                formData.append('AssignedUsers', JSON.stringify(self.getSelectedAssignedUsers()));
                formData.append('AssignedActionItems', JSON.stringify(self.getSelectedActionItems()));
                const pascalCaseChangedActionItems = mapKeysToPascalCase(self.changedActionItems);
                formData.append('ChangedActionItems', JSON.stringify(pascalCaseChangedActionItems));
                // Add attachments
                self.attachments.filter(att => att.id === 0 && att.file).forEach((att, idx) => {
                    formData.append(`Files`, att.file);
                    formData.append(`AttachmentTypeIds`, att.typeId);
                    formData.append(`OtherDescription`, att.otherDescription);
                });
                // Add excludedfiles header if any removed S3Ids
                let headers: any = {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() as string
                };
                if (self.excludedS3Ids.length > 0) {
                    headers["excludedfiles"] = self.excludedS3Ids.join("|");
                }
                $.ajax({
                    url: '/secure/ctms/communications/communications?handler=SaveCommunicationEvent',
                    method: 'POST',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: formData,
                    headers: headers,
                    success: (response) => {
                        $('#newCommunicationEventDialog').modal('hide');
                        if (this.successCallback) this.successCallback(response);
                    },
                    error: function (xhr) {
                        alert('Error saving communication event.');
                    }
                }).always(function () {
                    $('#saveCommunicationEventDialogBtn').prop('disabled', false);
                    $('#communicationEventSaveSpinner').hide();
                });
            }
        });
    }

    validateForm(): boolean {
        const fileInput = $('#communicationsFile')[0] as HTMLInputElement;
        const filePresent = fileInput.files && fileInput.files.length > 0;

        if (filePresent) {
            $('#validation-error-file').removeClass('d-none');
            return false;
        } else {
            $('#validation-error-file').addClass('d-none');
        }
        if (this.checkedSiteIds.size < 1) {
            $('#validation-error-site').removeClass('d-none');
            return false;
        }
        const dateValue = $('#communicationDate').val();
        const typeValue = $('#communicationType').val();
        const statusValue = $('#communicationStatus').val();
        const topicValue = $('#communicationTopic').val();

        if (!dateValue || !typeValue || !statusValue || !topicValue) {
            $('#validation-error').removeClass('d-none');
            return false;
        }
        return true;
    }

    getSelectedAssignedSites(): number[] {
        return Array.from(this.checkedSiteIds);
    }

    getSelectedAssignedSitesDetailed(): { SiteStudyId: number, SiteId: number }[] {
        return Array.from(this.checkedSiteIds).map(siteId => {
            const site = this.allSites.find(s => s.Id === siteId);
            return site
                ? { SiteStudyId: site.Id, SiteId: site.SiteId }
                : null;
        }).filter(x => x !== null);
    }

    getSelectedAssignedContacts(): number[] {
        return Array.from(this.checkedContactIds);
    }

    getSelectedAssignedUsers(): number[] {
        return Array.from(this.checkedUserIds);
    }

    getSelectedActionItems(): number[] {
        return Array.from(this.checkedActionItemIds);
    }

    populateDialogFieldsFromDto(dto: any): void {
        // Set basic fields
        $('#communicationId').val(dto.id);
        $('#communicationType').val(dto.typeId);
        $('#communicationTopic').val(dto.topicId);
        $('#communicationStatus').val(dto.statusId);
        $('#communicationDate').val(dto.date);
        $('#communicationNotes').val(dto.notes);
        $('#communicationEventSignificant').prop('checked', !!dto.isSignificant);

        // Assigned Sites
        this.checkedSiteIds.clear();
        if (Array.isArray(dto.assignedSites)) {
            dto.assignedSites.forEach((id: number) => this.checkedSiteIds.add(id));
        }
        if (this.sitesTable) this.sitesTable.draw();
        // Assigned Contacts
        this.checkedContactIds.clear();
        if (Array.isArray(dto.assignedContacts)) {
            dto.assignedContacts.forEach((id: number) => this.checkedContactIds.add(id));
        }
        if (this.contactsTable) this.contactsTable.draw();
        // Assigned Users
        this.checkedUserIds.clear();
        if (Array.isArray(dto.assignedUsers)) {
            dto.assignedUsers.forEach((id: number) => this.checkedUserIds.add(id));
        }
        if (this.usersTable) this.usersTable.draw();
        // Assigned Action Items
        this.checkedActionItemIds.clear();
        if (Array.isArray(dto.actionItems)) {
            dto.actionItems.forEach((ai: any) => this.checkedActionItemIds.add(ai.id));
        }
        // Update checked counts
        this.updateCheckedCounts();

        // Prepopulate attachment pills
        this.attachments = [];
        // Populate excludedS3Ids with all S3Ids from initial attachments
        this.excludedS3Ids = Array.isArray(dto.attachments)
            ? dto.attachments.filter((att: any) => !!att.s3Id).map((att: any) => att.s3Id)
            : [];
        if (Array.isArray(dto.attachments)) {
            dto.attachments.forEach((att: any) => {
                this.attachments.push({
                    id: att.id,
                    file: null,
                    typeId: att.attachmentTypeId?.toString() ?? '',
                    fileName: att.fileName ?? '',
                    s3Id: att.s3Id,
                    otherDescription: att.otherDescription ?? ''
                });
            });
            this.renderAttachmentPills();
            this.renderAttachmentsTable();
        }
        else {
            this.renderAttachmentPills();
            this.renderAttachmentsTable();
        }
        this.initializeAttachmentsFilters();
        // Populate action items table
        const pascalCaseActionItems = mapKeysToPascalCase(dto.actionItems);
        this.populateActionItemsTable(pascalCaseActionItems || []);
    }

    populateActionItemsTable(actionItems: any[]): void {
        this.actionItems = actionItems || [];
        this.actionItemsTable.clear();
        this.actionItemsTable.rows.add(this.actionItems).draw();
        this.initializeActionItemsFilters();
    }

    populateActionItemFieldsFromDto(dto: any): void {
        $('#commActionItemId').val(dto.id);
        $('#commActionItemType').val(dto.typeId).trigger('change');
        $('#commActionItemSource').val(dto.source);
        $('#commActionItemStatus').val(dto.statusId).trigger('change');
        $('#commActionItemDate').val(dto.dateIdentified);
        $('#commActionItemDueDate').val(dto.dateDue);
        $('#commActionItemUrgent').prop('checked', !!dto.isUrgent);
        $('#commActionItemCritical').prop('checked', !!dto.isCritical).trigger('change');
        $('#commActionItemCriticalType').val(dto.criticalTypeId || '').trigger('change');
        $('#commActionItemNotes').val(dto.notes);
    }

    private renderAttachmentPills(): void {
        const $container = $('#attachmentPills');
        $container.empty();
        // Only show attachments with id === 0
        this.attachments.filter(att => att.id === 0).forEach((att, idx) => {
            // Get file extension
            const fileName = att.fileName || '';
            const extMatch = fileName.match(/\.([^.]+)$/);
            const ext = extMatch ? extMatch[1].toLowerCase() : '';
            const iconHtml = this.getFileIcon(ext);
            const pill = $(`
            <span class="badge badge-pill mr-2">
                ${iconHtml} ${fileName}
                <span class="ml-1" style="cursor:pointer;" data-idx="${idx}">&times;</span>
            </span>
        `);
            pill.find('span[data-idx]').on('click', () => {
                // Remove S3Id from excludedS3Ids when pill is removed
                const filteredAttachments = this.attachments.filter(att => att.id === 0);
                if (filteredAttachments[idx] && filteredAttachments[idx].s3Id) {
                    this.excludedS3Ids = this.excludedS3Ids.filter(s3Id => s3Id !== filteredAttachments[idx].s3Id);
                }
                // Remove the correct attachment from the main attachments array
                const removeIndex = this.attachments.indexOf(filteredAttachments[idx]);
                if (removeIndex !== -1) {
                    this.attachments.splice(removeIndex, 1);
                }
                this.renderAttachmentPills();
            });
            $container.append(pill);
        });
    }

    private renderActionItemPills(): void {
        const $container = $('#commActionItemPills');
        $container.empty();
        this.changedActionItems.forEach((item, idx) => {
            const pill = $(`
            <span class="badge badge-pill mr-2">
                ${item.TypeName || ''} ${item.DateDue ? ' - Due: ' + item.DateDue : ''}
                <span class="ml-1" style="cursor:pointer;" data-idx="${idx}">&times;</span>
            </span>
        `);
            pill.find('span[data-idx]').on('click', () => {
                this.changedActionItems.splice(idx, 1);
                this.renderActionItemPills();
            });
            $container.append(pill);
        });
    }

    private getFileIcon(ext: string): string {
        switch (ext) {
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
            case 'bmp':
            case 'svg':
                return `<i class="fas fa-file-image expand-btn"></i>`;
            case 'pdf':
                return `<i class="fa-solid fa-file-pdf expand-btn"></i>`;
            case 'doc':
            case 'docx':
                return `<i class="fa-solid fa-file-word expand-btn"></i>`;
            case 'xls':
            case 'xlsx':
            case 'csv':
                return `<i class="fa-solid fa-file-excel expand-btn"></i>`;
            case 'ppt':
            case 'pptx':
                return `<i class="fa-solid fa-file-powerpoint expand-btn"></i>`;
            case 'mp3':
            case 'wav':
            case 'ogg':
                return `<i class="fa-solid fa-file-audio expand-btn"></i>`;
            case 'mp4':
            case 'avi':
            case 'mov':
            case 'wmv':
                return `<i class="fa-solid fa-file-video expand-btn"></i>`;
            default:
                return `<i class="fa-solid fa-file expand-btn"></i>`;
        }
    }
}

function mapKeysToPascalCase(obj: any): any {
    if (Array.isArray(obj)) {
        return obj.map(mapKeysToPascalCase);
    }
    if (obj !== null && typeof obj === 'object') {
        const newObj: any = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
                newObj[pascalKey] = mapKeysToPascalCase(obj[key]);
            }
        }
        return newObj;
    }
    return obj;
}